import React, { Component } from "react";
import { Button, FormGroup, FormControl, FormLabel, Image } from "react-bootstrap";
import { Auth } from "aws-amplify";
import "./index.css";
import  { Redirect } from 'react-router-dom'
import store from "./store/index";
import { updateBackStakeSetting, updateCommissionSetting, updateLayStakeSetting, updateTimeSettingsOneByOne } from "./actions/index";
import { updateFilteredCountryList } from "./actions/index";
import { updateExactTimeSettingsOneByOne } from "./actions/index";
import {update_Is_Exact_Time_One_By_One} from "./actions/index";
import {updateT0Settings} from "./actions/index";
import {update_Steamer_Drifter_Settings} from "./actions/index";
import { Link } from "react-router-dom";
import {updateLocalTimeOffSetToGmt} from "./actions/index";
import {updateLocalTimeZone} from "./actions/index";
import {updateLatestOddsSettings} from "./actions/index";

let user =null
let errorMsg = null

class Login extends Component {

  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      redirect: false,
      isPwChangeNeeded: false,
      isPwError: false
    };
  }

  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }
  // handleSubmit = event => {
  //   event.preventDefault();
  // }

  handleSubmit = async event => {
  event.preventDefault();

try {
  if(this.state.isPwChangeNeeded){


    const loggedUser = await Auth.completeNewPassword(
        user,               // the Cognito User Object
        this.state.password,       // the new password
    );

    //console.log("Confirmed user 444 : "+loggedUser);
    this.props.userHasAuthenticated(true,this.state.email);
    this.loadDetails()
    this.setState({
      isPwChangeNeeded: false,
      redirect: true,
      isPwError: false
    })


  }
  else{
    user = await Auth.signIn(this.state.email, this.state.password);

    if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {

    } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        const { requiredAttributes } = user.challengeParam;
        // the array of required attributes, e.g ['email', 'phone_number']
        // You need to get the new password and required attributes from the UI inputs
        // and then trigger the following function with a button click
        // For example, the email and phone_number are required attributes

        //console.log("Please enter new password!!!");
        this.setState({
          isPwChangeNeeded: true
        })

    } else if (user.challengeName === 'MFA_SETUP') {
    } else {
      //console.log("Logged in....");

      const user =  await Auth.currentAuthenticatedUser();
      const userGroups = user.signInUserSession.accessToken.payload["cognito:groups"];
      if(userGroups === undefined || !userGroups.includes("greyhound-price-monitor")) {
          throw new Error("You don't have access to this application. Please contact site administrator.");
      }
    
      this.props.userHasAuthenticated(true,this.state.email);
      this.loadDetails()
      //console.log(user)
    }
  }
}catch (err) {
    errorMsg = err.message
    this.setState({
      isPwError:true
    })
    if (err.code === 'UserNotConfirmedException') {}
    else if (err.code === 'PasswordResetRequiredException') {}
    else if (err.code === 'NotAuthorizedException') {}
    else if (err.code === 'UserNotFoundException') {}
    else {}
}
}
async isUserAuthenticated(){
  try {
  const info = await Auth.currentUserInfo()
  return true
  }catch (e) {
    //console.log("Error");
    return false
//alert(e.message);
  }
}
async loadDetails(){
  try {
  const info = await Auth.currentUserInfo()
  //console.log('Returned info:: ', info)
  
  let payload={}
  payload.id = "t1"
  payload.value = info.attributes["custom:gh:t1"]
  store.dispatch(updateTimeSettingsOneByOne(payload))

  payload.id = "t2"
  payload.value = info.attributes["custom:gh:t2"]
  store.dispatch( updateTimeSettingsOneByOne(payload))

  payload.id = "t3"
  payload.value = info.attributes["custom:gh:t3"]
  store.dispatch( updateTimeSettingsOneByOne(payload))

  payload.id = "t4"
  payload.value = info.attributes["custom:gh:t4"]
  store.dispatch( updateTimeSettingsOneByOne(payload))

  payload.id = "t5"
  payload.value = info.attributes["custom:gh:t5"]
  store.dispatch( updateTimeSettingsOneByOne(payload))

  payload.id = "t6"
  payload.value = info.attributes["custom:gh:t6"]
  store.dispatch( updateTimeSettingsOneByOne(payload))

  payload.id = "t0"
  payload.value = info.attributes["custom:gh:t0"].split("|")[0]
  store.dispatch(updateTimeSettingsOneByOne(payload))

  payload.id = "commision"
  payload.value = info.attributes["custom:gh:t0"].split("|")[1]
  store.dispatch(updateCommissionSetting(payload))

  payload.id = "backStake"
  payload.value = info.attributes["custom:gh:t0"].split("|")[2]
  store.dispatch(updateBackStakeSetting(payload))

  payload.id = "layStake"
  payload.value = info.attributes["custom:gh:t0"].split("|")[3]
  store.dispatch(updateLayStakeSetting(payload))


  payload.id = "diff"
  payload.value = info.attributes["custom:gh:t0"].split("|")[0]
  store.dispatch( updateT0Settings(payload))

  payload.id = "t1"
  payload.value = info.attributes["custom:gh:exact_t1"]
  store.dispatch(updateExactTimeSettingsOneByOne(payload))

  payload.id = "t2"
  payload.value = info.attributes["custom:gh:exact_t2"]
  store.dispatch( updateExactTimeSettingsOneByOne(payload))

  payload.id = "t3"
  payload.value = info.attributes["custom:gh:exact_t3"]
  store.dispatch( updateExactTimeSettingsOneByOne(payload))

  payload.id = "t4"
  payload.value = info.attributes["custom:gh:exact_t4"]
  store.dispatch( updateExactTimeSettingsOneByOne(payload))

  payload.id = "t5"
  payload.value = info.attributes["custom:gh:exact_t5"]
  store.dispatch( updateExactTimeSettingsOneByOne(payload))

  payload.id = "t6"
  payload.value = info.attributes["custom:gh:exact_t6"]
  store.dispatch( updateExactTimeSettingsOneByOne(payload))

  
  const tValue = info.attributes["custom:gh:t0_type"]
    

    payload.id = "t0"
    payload.value = tValue.split("|")[0]
    store.dispatch(updateExactTimeSettingsOneByOne(payload))

    payload.id = "t1"
    payload.value = tValue.split("|")[1]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t2"
    payload.value = tValue.split("|")[2]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t3"
    payload.value = tValue.split("|")[3]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))

    payload.id = "t4"
    payload.value = tValue.split("|")[4]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t5"
    payload.value = tValue.split("|")[5]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t6"
    payload.value = tValue.split("|")[6]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    
    payload.id = "option"
    payload.value = tValue.split("|")[0]
    store.dispatch( updateT0Settings(payload))

    // load latestOddsSettings

    //Steamer Drifter Settings
    const steamerDrifter = info.attributes["custom:gh:t1_type"]
    payload.id = "STEAMER_MIN_PRICE"
    payload.value = steamerDrifter.split("|")[0]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "STEAMER_MAX_PRICE"
    payload.value = steamerDrifter.split("|")[1]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "DRIFTER_MIN_PRICE"
    payload.value = steamerDrifter.split("|")[2]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "DRIFTER_MAX_PRICE"
    payload.value = steamerDrifter.split("|")[3]
    store.dispatch( update_Steamer_Drifter_Settings(payload))


    const volumeCountry = info.attributes["custom:gh:t2_type"]

    payload.id = "MIN_VOLUME"
    payload.value = volumeCountry.split("|")[0]
    store.dispatch( update_Steamer_Drifter_Settings(payload))

    let filteredCountryList = volumeCountry.split("|")[1]
    var Arr = filteredCountryList.split(',');
    store.dispatch(updateFilteredCountryList(Arr))
    //('Returned info:: ', filteredCountryList)

    payload.id = "tickUntilActualStart"
    payload.value = volumeCountry.split("|")[2]
    store.dispatch(updateLatestOddsSettings(payload))

    payload.id = "noOfSeconds"
    payload.value = volumeCountry.split("|")[3]
    store.dispatch(updateLatestOddsSettings(payload))

  const offset = new Date().getTimezoneOffset() * -1;
  const timezone = this.convertMinutesToLocalTimeZone(offset);
  //console.log("timezone offset: " + offset + ", timezone: " + timezone);
  store.dispatch(updateLocalTimeOffSetToGmt(offset));
  store.dispatch(updateLocalTimeZone(timezone));

  }catch (e) {
  console.log("Error");
  //alert(e.message);
  }
  this.setRedirect()
  //window.location.reload()
}
renderRedirect = () => {
  //console.log("this.state.redirect"+this.state.redirect+ " is user authenticated "+this.props.isAuthenticated);
   if (this.state.redirect || this.props.isAuthenticated) {
     //console.log("redirect to app");
     return <Redirect to='/app' />
   }
 }

 renderPwChangeError = () => {
   //console.log("Pw changes is needed : "+this.state.isPwChangeNeeded);
    if (this.state.isPwError) {
      return (
        <div className="thry2">*{errorMsg}</div>
      )
    }
  }

 renderPwChangeUIHeader = () => {
   //console.log("Pw changes is needed : "+this.state.isPwChangeNeeded);

    if (this.state.isPwChangeNeeded) {
      return (
        <div className="thry">Please Change the password. . Password minimum length is 8 and should adhere to the password policy.</div>
      )
    }
  }

 renderPwChangeUIBtn = () => {
   //console.log("Pw changes is needed : "+this.state.isPwChangeNeeded);

    if (this.state.isPwChangeNeeded) {
      return (
        <Button
          block
          bsSize="large"
          disabled={!this.validateForm()}
          type="submit"
        >
          Change Password
        </Button>
      )
    }
    else{
      return(
        <Button
          block
          bsSize="large"
          disabled={!this.validateForm()}
          type="submit"
        >
          Login
        </Button>
      )
    }
  }

  render() {
    const headerImage = (
      <div style={{textAlign: 'center', marginBottom: '20px'}}>
        <Image src={require('./assets/header_gpm.jpg')} fluid />
      </div>
    );

    const footerImage = (
      <div style={{textAlign: 'center', marginTop: '30px'}}>
        <a href="https://www.easybetbot.com" target="_blank">
          <Image src={require('./assets/header_easybetbot.png')} fluid />
        </a>
      </div>
    );

    return (
      <div className="Login">
      {headerImage}
      {this.renderRedirect()}
      {this.renderPwChangeUIHeader()}
        <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="email" bsSize="large">
            <FormLabel>Email</FormLabel>
            <FormControl
              autoFocus
              type="email"
              value={this.state.email}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup controlId="password" bsSize="large">
            <FormLabel>Password</FormLabel>
            <FormControl
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
            />
          </FormGroup>
          <Link to="/login/reset">Forgot password?</Link>
          {this.renderPwChangeError()}
          {this.renderPwChangeUIBtn()}
        </form>
        {footerImage}
      </div>
    );
  }
}

export default Login
